import * as service from './service'
import { me } from '../auth/service'
import notification from '@components/notification'
import { capitalize, getMessages } from '@helpers/index'
import { GOOGLE_CONNECTED_ALREADY_ERROR_MSG } from '@helpers/constants'
import { setActiveTotalAccounts } from '@helpers/utility'

export default {
  state: {
    staffs: [],
    fields: [],
    activityList: [],
    primaryCategories: [],
    boardingCategories: [],
    boardingCategoriesOther: [],
    secondaryCategories: [],
    loading: true,
    gmbData: [],
    apiError: false,
    selectedSocialDetails: [],
    facebookData: '',
    selectedFacebookPage: {},
    goalsList: '',
    isGbmEnabled: null,
    isGmbActive: null,
    editField: null,
    gmbDataOfUser: {}
  },
  reducers: {
    onRequest(state) {
      return {
        ...state,
        loading: true,
        apiError: false
      }
    },
    onSuccess(state, data, msg) {
      if (msg) {
        notification('success', msg)
      }
      return {
        ...state,
        loading: false
      }
    },
    onError(state, data) {
      let err =
        data && data.data && data.data.status && data.data.status.messageDescription
          ? data.data.status.messageDescription
          : data && data.status && data.status.messageDescription
          ? data.status.messageDescription
          : data && data.message
          ? data.message
          : data && data.data && data.data.message
          ? data.data.message
          : data && data.error
          ? data.error
          : data && data.data && data.data.error
          ? data.data.error
          : 'Something Went Wrong'
      if (err && Array.isArray(err) && err.includes('Business hours overlapped')) {
        err = 'Overlapping time slots found in business hours'
      } else if (err && typeof err === 'string' && err.includes(GOOGLE_CONNECTED_ALREADY_ERROR_MSG)) {
        err = GOOGLE_CONNECTED_ALREADY_ERROR_MSG
      }
      notification('error', capitalize(err))
      return {
        ...state,
        loading: false,
        apiError: true
      }
    },
    onbusinessSuccess(state, data, msg) {
      if (msg) {
        notification('success', msg)
      }

      let businessSettings = data && data.location ? data.location : data && Object.keys(data).length ? data : null
      console.log('get businessSettings--------------------------------')
      if (localStorage.getItem('saveLocal') === 'true' && localStorage.getItem('businessSettings')) {
        businessSettings = JSON.parse(localStorage.getItem('businessSettings'))
        console.log('businessSettings fetch from local')
      }
      return {
        ...state,
        businessSettings,
        loading: false,
        apiError: false
      }
    },
    onUpdateBusinessSettingsLocalSuccess(state, data) {
      const businessSettings = { ...state.businessSettings, ...data }

      localStorage.setItem('businessSettings', JSON.stringify(businessSettings))
      return {
        ...state,
        loading: false,
        businessSettings
      }
    },
    getStaffUsersSuccess(state, data) {
      return {
        ...state,
        loading: false,
        staffs: data
      }
    },
    getCustomFieldsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        fields: data.customFields
      }
    },
    getCustomFieldSuccess(state, data) {
      return {
        ...state,
        loading: false,
        editField: data
      }
    },
    onactivities(state, data) {
      return {
        ...state,
        loading: false,
        activityList: data
      }
    },
    onGetPrimaryCategoriesSuccess(state, data) {
      return {
        ...state,
        loading: false,
        primaryCategories: data
      }
    },
    onGetOnboardingCategoriesSuccess(state, data) {
      return {
        ...state,
        loading: false,
        boardingCategories: data
      }
    },
    onGetOnboardingCategoriesOtherSuccess(state, data) {
      return {
        ...state,
        loading: false,
        boardingCategoriesOther: data
      }
    },
    onGetSeconderyCategoriesSuccess(state, data) {
      return {
        ...state,
        loading: false,
        secondaryCategories: data
      }
    },
    onUpdateMediaPhotoNameSuccess(state) {
      notification('success', 'Photo description successfully updated')
      return {
        ...state,
        loading: false
      }
    },
    onUpdateStaffStatusSuccess(state, data, status) {
      if (status) {
        let msg = ''
        if (status === 'active') {
          msg = 'User enabled successfully'
        } else if (status === 'inactive') {
          msg = 'User disabled successfully'
        } else if (status === 'deleted') {
          msg = 'User deleted successfully'
        }
        if (msg) {
          notification('success', msg)
        }
      }
      return {
        ...state,
        loading: false
      }
    },
    onSyncSuccess(state, data) {
      notification('success', data.data ? data.data : data.message)
      return {
        ...state,
        loading: false
      }
    },
    onSocialConnectionsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        socialConnections: data.data
      }
    },
    onfetchSmsThemeSuccess(state, data) {
      return {
        ...state,
        loading: false,
        smsTemplates: data
      }
    },
    onDeleteMediaPhotoSuccess(state) {
      return {
        ...state,
        loading: false
      }
    },
    onDeleteMediaVideoSuccess(state, data) {
      notification('success', 'Video deleted successfully')
      return {
        ...state,
        loading: false,
        data: data
      }
    },

    onResetUserAccountSuccess(state) {
      notification('success', 'A reset password link has been sent to this user')
      return {
        ...state,
        loading: false
      }
    },
    onQuickLoginSuccess(state) {
      notification('success', 'A quick login link has been sent to this user')
      return {
        ...state,
        loading: false
      }
    },
    onCreateStaffSuccess(state, data) {
      notification('success', 'The staff has been created successfully')
      let newStaffId = ''
      if (data && data.data) {
        newStaffId = data.data
      }
      return {
        ...state,
        loading: false,
        apiError: false,
        newStaffId: newStaffId
      }
    },
    onDeleteCustomFieldSuccess() {
      notification('success', 'The custom field has been deleted successfully')
    },
    onEditCustomFieldSuccess(state, data) {
      notification('success', 'The custom field has been updated successfully')
      let editField = ''
      if (data) {
        editField = data
      }
      return {
        ...state,
        loading: false,
        apiError: false,
        editField: editField
      }
    },
    onCreateCustomFieldSuccess(state, data) {
      notification('success', 'The custom field has been created successfully')
      let newFieldId = ''
      if (data) {
        newFieldId = data
      }
      return {
        ...state,
        loading: false,
        apiError: false,
        newFieldId: newFieldId
      }
    },
    onUserRolePermissions(state) {
      notification('success', 'The staff permission updated successfully')
      return {
        ...state,
        loading: false
      }
    },
    onGetGmbDataOfUser(state, data) {
      return {
        ...state,
        loading: false,
        gmbDataOfUser: data
      }
    },
    onBeforeGetGmbAccounts(state, data) {
      return {
        ...state,
        loading: true,
        gmbData: []
      }
    },
    onGetGmbAccountsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        gmbData: data
      }
    },
    ontriggerContactSalesSuccess(state, data) {
      return {
        ...state,
        contactSalesStatus: data
      }
    },
    ontriggerContactSalesError(state, data) {
      return {
        ...state,
        contactSalesStatus: data
      }
    },
    setFacebookData(state, data) {
      return {
        ...state,
        loading: false,
        facebookData: data
      }
    },
    onSelectedSocialDetails(state, data) {
      return {
        ...state,
        loading: false,
        selectedSocialDetails: data
      }
    },
    onSetSelectedFacebookPage(state, data) {
      return {
        ...state,
        loading: false,
        selectedFacebookPage: data
      }
    },
    onGetGmbLocationsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        gmbLocations: data && data.data
      }
    },
    onGmbActive(state, data) {
      let response = null
      if (data.status.statusCode === 1) {
        response = true
      } else if (data.status.statusCode === 0) {
        response = false
      }
      return {
        ...state,
        loading: false,
        isGmbActive: response
      }
    },
    onGbmEnabled(state, data) {
      let response = null
      if (data.status.statusCode === 1) {
        response = true
      } else if (data.status.statusCode === 0) {
        response = false
      }
      return {
        ...state,
        loading: false,
        isGbmEnabled: response
      }
    },
    onEmbedChatScriptSuccess(state, data) {
      return {
        ...state,
        loading: false,
        embedcode: data.data
      }
    },
    onEmbedBookingScriptSuccess(state, data) {
      return {
        ...state,
        loading: false,
        bookingEmbedCode: data.data
      }
    },
    ongetMenuLocationsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        locationMenus: data.data
      }
    },
    onGetsettings(state, data) {
      return {
        ...state,
        loading: false,
        goalsList: data
      }
    },
    onaddSectionitemSuccess(state, data) {
      notification('success', 'Menu section added')
      return {
        ...state,
        loading: false,
        newAddedSection: data.data
      }
    },
    onfetchUserRolePermissionsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        teamUserPermissions: data && data.data
      }
    },
    ongetUserSuccess(state, data) {
      return {
        ...state,
        loading: false,
        teamUserData: data
      }
    },
    onGetCalendarDataSuccess(state, data) {
      return {
        ...state,
        loading: false,
        teamUserCalendar: data && data.data
      }
    },
    onupdateStaffUserSuccess(state, data, msg) {
      if (msg) {
        notification('success', msg)
      }
      return {
        ...state,
        loading: false
      }
    },
    onSendWelcomeMessageSuccess(state, data, msg) {
      if (msg) {
        notification('success', msg)
      }
      return {
        ...state,
        loading: false
      }
    },
    ongetActivityListSuccess(state, data) {
      let delCount = 0
      let activitiesTotl = 0
      for (let i = data.docs.length - 1; i >= 0; i--) {
        if (data.docs[i].meta_data && data.docs[i].meta_data.succesful === 0) {
          data.docs[i].delstatus = 'deleted'
          delCount++
        }
      }
      for (let i = data.docs.length - 1; i >= 0; i--) {
        if (!data.docs[i].status || (data.docs[i].status && data.docs[i].status !== 'canceled')) {
          if (data.docs[i].display_message) activitiesTotl++
        }
      }
      let array = data.docs && data.docs.length ? data.docs : []
      if (state.teamActivityList && state.teamActivityList.docs && state.teamActivityList.docs.length) {
        array = [...state.teamActivityList.docs, ...array]
      }
      data.docs = array
      return {
        ...state,
        loading: false,
        teamActivityList: data,
        activitiesTotl: activitiesTotl,
        delCount: delCount
      }
    },
    unLinkCalendarSuccess(state, data, msg) {
      if (msg) {
        notification('success', msg)
      }
      return {
        ...state,
        loading: false
      }
    },
    onGetMenuOptionsSuccess(state, data) {
      return {
        ...state,
        loading: false,
        menuLabel: data && data.data
      }
    },
    clearTeamActivityData(state) {
      return {
        ...state,
        loading: false,
        teamActivityList: null,
        activitiesTotl: null,
        delCount: null
      }
    }
  },

  effects: {
    async fetchBusinessSettings(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.fetchBusinessSettings(payload)
        this.onbusinessSuccess(res.data)
        return res
      } catch (e) {
        // this.onError(e);
        console.log(e)
      }
    },
    async getServiceAreas(payload) {
      this.onRequest()
      try {
        const res = await service.getServiceAreas(payload)
        this.onbusinessSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updateBusinessSettings(payload) {
      const throwBackErr = payload.throwBackErr
      delete payload.throwBackErr
      try {
        const type = payload.type
        const saveLocal = localStorage.getItem('saveLocal') === 'true'
        let res
        console.log('-------------- here saveLocal-----------------', saveLocal, localStorage.getItem('saveLocal'))
        if (saveLocal) {
          this.onUpdateBusinessSettingsLocalSuccess(payload)
        } else {
          res = await service.updateBusinessSettings(payload)
          this.onbusinessSuccess(res, type && res && !res.errorMsgCreateJiraTicketUberall ? getMessages(type) : null)
          if (res && res.errorMsgCreateJiraTicketUberall) {
            notification('error', res.errorMsgCreateJiraTicketUberall)
          }
        }
        return res
      } catch (e) {
        this.onError(e)
        if (throwBackErr) {
          throw e
        }
      }
    },
    async getStaffUsers(data) {
      this.onRequest()
      try {
        const res = await service.getStaffUsers(data)
        this.getStaffUsersSuccess(res.docs)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getCustomFields() {
      this.onRequest()
      try {
        const res = await service.getCustomFields()
        this.getCustomFieldsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getCustomField(fieldId) {
      this.onRequest()
      try {
        const res = await service.getCustomField(fieldId)
        this.getCustomFieldSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async deleteCustomField(fieldId) {
      try {
        const res = await service.deleteCustomField(fieldId)
        this.onDeleteCustomFieldSuccess(res)
        return res
      } catch (e) {
        notification('error', capitalize(e && e.data && e.data.error))
        this.onError(e)
      }
    },
    async activities(data) {
      this.onRequest()
      try {
        const res = await service.activities(data)
        await this.onactivities(res.docs)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getPrimaryCategories(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getCategories(payload)
        this.onGetPrimaryCategoriesSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getSecondaryCategories(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getCategories(payload)
        this.onGetSeconderyCategoriesSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getOnboardingCategories(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getOnboardingCategories(payload)
        this.onGetOnboardingCategoriesSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getOnboardingCategoriesOther(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getOnboardingCategories(payload)
        this.onGetOnboardingCategoriesOtherSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },

    async updateMediaPhotoName(payload) {
      this.onRequest()
      try {
        const res = await service.updateMediaPhotoName(payload)
        this.onUpdateMediaPhotoNameSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async triggerContactSales(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.triggerContactSales(payload)
        this.ontriggerContactSalesSuccess(res, payload)
        return res
      } catch (e) {
        console.log(e)
        this.ontriggerContactSalesError(e)
      }
    },
    async facebookSync(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.facebookSync(payload)
        this.onSyncSuccess(res)
        return res
      } catch (e) {
        if (e && e.data && e.data.error) {
          notification('error', capitalize(e.data.error))
        } else {
          this.onError(e)
        }
      }
    },
    async facebookUnSync(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.facebookUnSync(payload)
        this.onSyncSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getSocialConnections(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getSocialConnections(payload)
        this.onSocialConnectionsSuccess(res)
      } catch (e) {
        this.onError(e)
      }
    },
    async updateStaffStatus(payload) {
      this.onRequest()
      try {
        const res = await service.updateStaffStatus(payload)
        this.onUpdateStaffStatusSuccess(res.data, payload.status)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async fetchSmsTheme(payload) {
      this.onRequest()
      try {
        const res = await service.fetchSmsTheme(payload)
        this.onfetchSmsThemeSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },

    async getsettings(payload) {
      this.onRequest()
      try {
        const res = await service.getsettings(payload)
        await this.onGetsettings(res.settings)
        return res.settings
      } catch (e) {
        // this.onError(e);
        console.log(e)
      }
    },
    async deleteMediaPhoto(payload) {
      this.onRequest()
      try {
        const res = await service.deleteMediaPhoto(payload)
        if (res && res.errorMsgCreateJiraTicketUberall) {
          notification('error', res.errorMsgCreateJiraTicketUberall)
          this.onDeleteMediaPhotoSuccess(res.data)
        } else {
          notification('success', 'Successfully deleted photo')
          this.onDeleteMediaPhotoSuccess(res.data)
        }
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async deleteMediaVideo(payload) {
      this.onRequest()
      try {
        const res = await service.deleteMediaVideo(payload)
        this.onDeleteMediaVideoSuccess(res.data)
        return res
      } catch (e) {
        this.onError(e)
      }
    },

    async resetUserAccount(payload) {
      try {
        const res = await service.resetUserAccount(payload)
        this.onResetUserAccountSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async quickLogin(payload) {
      try {
        const res = await service.quickLogin(payload)
        this.onQuickLoginSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async createStaff(payload, state) {
      try {
        const res = await service.createStaff(payload)
        this.onCreateStaffSuccess(res)
        return res
      } catch (e) {
        notification('error', capitalize(e && e.data && e.data.error))
        this.onError(e)
      }
    },

    async createCustomField(payload, state) {
      try {
        const res = await service.createCustomField(payload)
        this.onCreateCustomFieldSuccess(res)
        return res
      } catch (e) {
        notification('error', capitalize(e && e.data && e.data.error))
        this.onError(e)
      }
    },

    async editCustomField(payload, state) {
      try {
        const res = await service.editCustomField(payload)
        this.onEditCustomFieldSuccess(res)
        return res
      } catch (e) {
        notification('error', capitalize(e && e.data && e.data.error))
        this.onError(e)
      }
    },

    async fetchUserRolePermissions(payload) {
      this.onRequest()
      try {
        const res = await service.fetchUserRolePermissions(payload)
        this.onfetchUserRolePermissionsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getGmbAccounts(payload, rootState) {
      try {
        const res = await service.getGmbAccounts(payload)
        // sample res from gmb
        // const res = {
        //   'accounts': [
        //     {
        //       'name': 'accounts/102737417257825406976',
        //       'accountName': 'Rohan Sudhir Bhore',
        //       'type': 'PERSONAL',
        //       'verificationState': 'UNVERIFIED',
        //       'vettedState': 'NOT_VETTED'
        //     }
        //   ]
        // }
        this.onGetGmbAccountsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getGMBDetailsFromGoogle(payload) {
      try {
        this.onBeforeGetGmbAccounts()
        const res = await service.getGMBDetailsFromGoogle(payload)
        this.onGetGmbAccountsSuccess(res.data)
        return res.data
      } catch (e) {
        notification('error', capitalize('GMB Account is not available Please Proceed without GMB'))
      }
    },
    setSelectedSocialDetails(payload) {
      try {
        this.onSelectedSocialDetails(payload)
      } catch (e) {
        this.error(e)
      }
    },
    setSelectedFacebookPage(payload) {
      try {
        this.onSetSelectedFacebookPage(payload)
      } catch (e) {
        this.error(e)
      }
    },
    async connectWithFacebook(payload) {
      try {
        const res = await service.connectFacebook(payload)
        this.setFacebookData(res.data)
        return res.data
      } catch (e) {
        notification('error', capitalize('Facebook Page is not available Please Proceed without Facebook Sync'))
        this.onError(e)
      }
    },
    async userRolePermissions(payload) {
      try {
        const res = await service.userRolePermissions(payload)
        this.onUserRolePermissions(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getGmbLocations(payload, rootState) {
      try {
        //  const res1 = { 'message': 'Success', 'data': [{ 'name': 'locations/3692385607928883086', 'languageCode': 'en', 'title': 'Valley Christian Schools', 'phoneNumbers': { 'primaryPhone': '(408) 513-2400' }, 'categories': { 'primaryCategory': { 'name': 'categories/gcid:awning_supplier', 'displayName': 'Awning supplier', 'serviceTypes': [{ 'serviceTypeId': 'job_type_id:delivery', 'displayName': 'Delivery' }], 'moreHoursTypes': [{ 'hoursTypeId': 'ACCESS', 'displayName': 'Access', 'localizedDisplayName': 'Access' }, { 'hoursTypeId': 'BREAKFAST', 'displayName': 'Breakfast', 'localizedDisplayName': 'Breakfast' }, { 'hoursTypeId': 'BRUNCH', 'displayName': 'Brunch', 'localizedDisplayName': 'Brunch' }, { 'hoursTypeId': 'DELIVERY', 'displayName': 'Delivery', 'localizedDisplayName': 'Delivery' }, { 'hoursTypeId': 'DINNER', 'displayName': 'Dinner', 'localizedDisplayName': 'Dinner' }, { 'hoursTypeId': 'DRIVE_THROUGH', 'displayName': 'Drive through', 'localizedDisplayName': 'Drive through' }, { 'hoursTypeId': 'HAPPY_HOUR', 'displayName': 'Happy hours', 'localizedDisplayName': 'Happy hours' }, { 'hoursTypeId': 'KITCHEN', 'displayName': 'Kitchen', 'localizedDisplayName': 'Kitchen' }, { 'hoursTypeId': 'LUNCH', 'displayName': 'Lunch', 'localizedDisplayName': 'Lunch' }, { 'hoursTypeId': 'ONLINE_SERVICE_HOURS', 'displayName': 'Online service hours', 'localizedDisplayName': 'Online service hours' }, { 'hoursTypeId': 'PICKUP', 'displayName': 'Pickup', 'localizedDisplayName': 'Pickup' }, { 'hoursTypeId': 'TAKEOUT', 'displayName': 'Takeout', 'localizedDisplayName': 'Takeout' }, { 'hoursTypeId': 'SENIOR_HOURS', 'displayName': 'Senior hours', 'localizedDisplayName': 'Senior hours' }] } }, 'storefrontAddress': { 'regionCode': 'US', 'languageCode': 'en', 'postalCode': '95111', 'administrativeArea': 'CA', 'locality': 'San Jose', 'addressLines': ['100 Skyway Dr #130, San Jose, CA, 95111'] }, 'websiteUri': 'http://www.vcs.net/', 'regularHours': { 'periods': [{ 'openDay': 'MONDAY', 'openTime': { 'hours': 9 }, 'closeDay': 'MONDAY', 'closeTime': { 'hours': 17 } }, { 'openDay': 'TUESDAY', 'openTime': { 'hours': 9 }, 'closeDay': 'TUESDAY', 'closeTime': { 'hours': 17 } }, { 'openDay': 'WEDNESDAY', 'openTime': { 'hours': 9 }, 'closeDay': 'WEDNESDAY', 'closeTime': { 'hours': 17 } }, { 'openDay': 'THURSDAY', 'openTime': { 'hours': 9 }, 'closeDay': 'THURSDAY', 'closeTime': { 'hours': 17 } }, { 'openDay': 'FRIDAY', 'openTime': { 'hours': 9 }, 'closeDay': 'FRIDAY', 'closeTime': { 'hours': 17 } }] }, 'openInfo': { 'status': 'OPEN', 'canReopen': true }, 'metadata': { 'canDelete': true, 'canModifyServiceList': true, 'placeId': 'ChIJ17MWrU5J2YARjvpA19_O0CI', 'mapsUri': 'https://maps.google.com/maps?cid=2508732453229755022', 'newReviewUri': 'https://search.google.com/local/writereview?placeid=ChIJ17MWrU5J2YARjvpA19_O0CI', 'canHaveBusinessCalls': true }, 'profile': { 'description': 'Some business description' } }] }
        const res = await service.getGmbLocations(payload)
        this.onGetGmbLocationsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async gmbImport(payload, rootState) {
      try {
        const res = await service.gmbImport(payload)
        this.onSuccess(res, 'Your Google account has been linked successfully')

        const meRes = await me()
        const configCat = await service.getConfigCatValue('gbmEnabled', meRes)
        if (configCat) {
          const gbmPayload = {}
          gbmPayload.accessToken = payload.access_token
          gbmPayload.refreshToken = payload.refresh_token
          gbmPayload.locationName = payload.location_name
          const responseGbm = await service.createGbmAgent(gbmPayload)
          await service.gbmEnabled()
          this.onSuccess(responseGbm, 'Business Message will be activated in couple of hours.')
        }

        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async gmbSync(payload, rootState) {
      try {
        const res = await service.gmbSync(payload)
        this.onSuccess(res, 'Your Google account has been synced successfully')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async gmbUnSync(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.gmbUnSync(payload)
        this.onSuccess(res, 'Google account unsynced successfully')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async gmbActive(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.gmbActive(payload)
        this.onGmbActive(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async gbmEnabled(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.gbmEnabled(payload)
        this.onGbmEnabled(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async createGbmAgent(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.createGbmAgent(payload)
        this.onSuccess(res, 'Google Business Message will be activated in couple of hours.')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updateGbmAgent(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.updateGbmAgent(payload)
        this.onSuccess(res, 'GBM agent updated')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getGmbDataOfUser(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getGmbDataOfUser(payload)
        this.onGetGmbDataOfUser(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getEmbedChatScript(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getEmbedChatScript(payload)
        this.onEmbedChatScriptSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getEmbedBookingScript(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getEmbedBookingScript(payload)
        this.onEmbedBookingScriptSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async sortPhotos(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.sortPhotos(payload)
        this.onbusinessSuccess(res, 'Photo reordered successfully')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async uploadBusinessPhoto(payload, rootState, hideToaster) {
      this.onRequest()
      try {
        const res = await service.uploadBusinessPhoto(payload)
        this.onbusinessSuccess(
          res,
          !hideToaster && res && !res.errorMsgCreateJiraTicketUberall ? 'Photo uploaded successfully' : ''
        )
        if (res && res.errorMsgCreateJiraTicketUberall) {
          notification('error', res.errorMsgCreateJiraTicketUberall)
        }
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getMenuLocations(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getMenuLocations(payload)
        this.ongetMenuLocationsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async addNewLocations(payload) {
      this.onRequest()
      try {
        const res = await service.upadteBusinessName(payload)
        const meRes = await me()
        this.onbusinessSuccess(res, 'New location added successfully')
        await new Promise((resolve) => setTimeout(resolve, 400))
        const { active_accounts, total_accounts } = meRes
        const { uuid } = setActiveTotalAccounts(active_accounts, total_accounts)
        return uuid
      } catch (e) {
        this.onError(e)
      }
    },
    async addNewGMBLocations(payload) {
      this.onRequest()
      try {
        const res = await service.createGMBLocation(payload)
        if (res) {
          const meRes = await me()
          this.onbusinessSuccess(res, 'New GMB location added successfully')
          await new Promise((resolve) => setTimeout(resolve, 400))
          const { active_accounts, total_accounts } = meRes
          const { uuid } = setActiveTotalAccounts(active_accounts, total_accounts)
          return uuid
        }
      } catch (e) {
        this.onError(e)
      }
    },
    async getUser(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getUser(payload)
        this.ongetUserSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getCalendarData(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getCalendarData(payload)
        this.onGetCalendarDataSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updateStaffUser(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.updateStaffUser(payload)
        this.onupdateStaffUserSuccess(res, 'User has been updated successfully')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async sendWelcomeMessage(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.sendWelcomeMessage(payload)
        this.onSendWelcomeMessageSuccess(res, 'Welcome mail sent successfully')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getTeamActivityList(payload, rootState) {
      this.onRequest()
      try {
        const res = await service.getActivityList(payload)
        this.ongetActivityListSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async unLinkCalendar(payload, data) {
      this.onRequest()
      try {
        const res = await service.unLinkCalendar(payload)
        this.unLinkCalendarSuccess(res, 'You have successfully unsynced calendar')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async addSectionitem(payload, data) {
      this.onRequest()
      try {
        const res = await service.addSectionitem(payload)
        this.onaddSectionitemSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updateSectionitem(payload, data) {
      this.onRequest()
      try {
        const res = await service.updateSectionitem(payload)
        this.onSuccess(res, 'Menu Section updated')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async getMenuOptions(payload) {
      this.onRequest()
      try {
        const res = await service.getMenuOptions(payload)
        this.onGetMenuOptionsSuccess(res)
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async createMenuItem(payload) {
      this.onRequest()
      try {
        const res = await service.createMenuItem(payload)
        this.onSuccess(res, 'Menu Item added')

        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async updateMenuItem(payload) {
      this.onRequest()
      try {
        const res = await service.updateMenuItem(payload)
        this.onSuccess(res, 'Menu Item updated')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async deleteMenuItem(payload) {
      this.onRequest()
      try {
        const res = await service.deleteMenuItem(payload)
        this.onSuccess(res, 'Menu Item Deleted')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async deleteMenuSection(payload) {
      this.onRequest()
      try {
        const res = await service.deleteMenuSection(payload)
        this.onSuccess(res, 'Menu Section deleted')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async createMenu(payload) {
      this.onRequest()
      try {
        const res = await service.createMenu(payload)
        this.onSuccess(res, 'Menu Added')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async editMenu(payload) {
      this.onRequest()
      try {
        const res = await service.editMenu(payload)
        this.onSuccess(res, 'Menu Updated')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async deleteMenu(payload) {
      this.onRequest()
      try {
        const res = await service.deleteMenu(payload)
        this.onSuccess(res, 'Menu deleted')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async reorderMenuItem(payload) {
      this.onRequest()
      try {
        const res = await service.reorderMenuItem(payload)
        this.onSuccess(res, 'Updated menu order')
        return res
      } catch (e) {
        this.onError(e)
      }
    },
    async flushTeamActivityData() {
      try {
        this.clearTeamActivityData()
        return true
      } catch (e) {
        console.log(e)
      }
    },
    async syncGMBPhoto(payload) {
      try {
        const res = await service.syncGMBPhoto(payload)
        this.onSuccess(res, 'Photo will be synced shortly')
        return res
      } catch (e) {
        // this.onError(e);
      }
    },
    async uberAllCategory(payload, rootState, module) {
      try {
        const res = await service.uberAllCategory(payload, module)
        return res
      } catch (e) {
        console.log(e)
      }
    },
    async updateBusinessArea(payload) {
      try {
        const res = await service.updateBusinessArea(payload)
        return res
      } catch (e) {
        this.onError(e)
      }
    }
  }
}
